(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vw-warranty-form-state"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'vitalwalk.warranty-draft.v1';
  const ttl = 30 * 60 * 1000;
  const names = ['name', 'email', 'Purchase channel', 'seller', 'Order number', 'Purchase date', 'Product model', 'serial', 'body'];
  let expiryTimer;
  const remove = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const initialize = () => {
    const container = document.querySelector('.vw-warranty__form');
    if (!container) return;
    if (container.querySelector('[data-warranty-received]')) { remove(); return; }
    const form = container.querySelector('form');
    if (!form || form.dataset.warrantyBound) return;
    form.dataset.warrantyBound = 'true';
    const date = form.querySelector('[data-warranty-date]');
    const today = new Date();
    if (date) date.max = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
    try {
      const draft = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (draft && typeof draft.expires === 'number' && draft.expires > Date.now()) {
        names.forEach(name => {
          const field = form.elements.namedItem('contact[' + name + ']');
          if (field && !field.value && typeof draft.fields?.[name] === 'string') field.value = draft.fields[name];
        });
        clearTimeout(expiryTimer);
        expiryTimer = setTimeout(remove, Math.min(ttl, draft.expires - Date.now()));
      } else { remove(); }
    } catch (_) { remove(); }
    const save = () => {
      const fields = {};
      names.forEach(name => { const field = form.elements.namedItem('contact[' + name + ']'); if (field) fields[name] = field.value; });
      try { sessionStorage.setItem(key, JSON.stringify({ expires: Date.now() + ttl, fields })); } catch (_) {}
      clearTimeout(expiryTimer);
      expiryTimer = setTimeout(remove, ttl);
    };
    form.addEventListener('input', save);
    form.addEventListener('change', save);
    form.addEventListener('submit', save);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
